import React, { useEffect, useState, useRef, useCallback } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import ValidateService from "../../../components/ValidateService/ValidateService";

// PAGE
import P233List_1 from "./P233List_1";

// SERVICE

// เพิ่มรายการใหม่
import { pP2P1List, pP2New } from "../../../service/200/P233Service";

export default function P233Edit_1() {
    const history = useHistory();

    const toast = useRef(null);
    const [loading, setLoading] = useState(false);

    // SEARCH
    const [searchData, setSearchData] = useState({ withdrawSeq: 0, contractNo: "", userId: dataUserSession() ? dataUserSession().userId : "" });

    // DATA
    const [count, setCount] = useState(0);
    const [dataTable, setDataTable] = useState({ dataTB: [], dataCB: [] });
    const [errData, setErrData] = useState(null);

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state && history.location.state.dataSrh) {
                setSearchData({
                    ...searchData,
                    ...history.location.state.dataSrh,
                });
            } else {
                history.push("/233");
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onGetpP2P1List();
    }, [searchData]);

    const onGetpP2P1List = () => {
        setLoading(true);
        pP2P1List(searchData).then(
            (res) => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let temp2 = [];
                    let index = 0;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        temp2.push({
                            p1Seq: element.p1Seq,
                            updateKey: element.updateKey,
                            flag: element.seqEnableFlag === "N" ? "Y" : "N",
                            seqEnableFlag: element.seqEnableFlag,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable({ dataTB: temp, dataCB: temp2 });
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const validateForm = () => {
        for (const iterator of dataTable.dataCB) {
            if (iterator.seqEnableFlag === "Y") {
                if (iterator.flag == "N") {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }
    };

    const submitForm = () => {
        setLoading(true);
        if (validateForm()) {
            let stringChk = "";
            for (const iterator of dataTable.dataCB) {
                if (iterator.flag === "Y") {
                    // stringChk += "|" + iterator.p1Seq;
                    stringChk += "|" + iterator.updateKey;
                }
            }
            const req = {
                contractNo: searchData.contractNo,
                selectItem: stringChk.replace(/^./g, ""),
                userId: searchData.userId,
            };
            pP2New(req).then(
                (res) => {
                    setLoading(false);
                    if (res.length > 0) {
                        handlerGoPage({ page: "233Edit_2", withdrawSeq: res[0].withdrawSeq });
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        } else {
            showMessages("error", "เกิดข้อผิดพลาด", "ต้องเลือกอย่างน้อย 1 รายการ");
        }
    };

    const handlerGoPage = (obj) => {
        switch (obj.page) {
            case "233Edit_2":
                history.push({
                    pathname: `/${obj.page}`,
                    state: {
                        dataSrh: {
                            contractNo: searchData.contractNo,
                            withdrawSeq: obj.withdrawSeq,
                        },
                    },
                });
                break;
            case "233":
                history.push({
                    pathname: `/${obj.page}`,
                    state: {
                        contractNo: searchData.contractNo,
                    },
                });
                break;

            default:
                break;
        }
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const handlerSelectBox = useCallback(
        (rowData, select) => {
            const chk = select == true ? "Y" : "N";
            const objIndex = dataTable.dataCB.findIndex((obj) => obj.index == rowData.index);
            dataTable.dataCB[objIndex].flag = chk;
            setCount(count + 1);
            setDataTable({ ...dataTable, dataCB: dataTable.dataCB });
        },
        [dataTable.dataCB, count]
    );

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <h3>เพิ่มรายการ P2</h3>
                        <hr />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2"></div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" type="text" value={searchData.contractNo} maxLength="20" disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">P2 งวดที่</label>
                                <InputText id="contractNo" type="text" value={searchData.withdrawSeq} maxLength="20" disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-2"></div>
                        </div>
                        <hr />
                        <P233List_1 dataTable={dataTable.dataTB} setDataClone={dataTable.dataCB} setSelected={handlerSelectBox} />

                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <Button className="p-button-success p-button btn-hidden-responsive" icon="pi pi-save" label="บันทึก" style={{ width: 170 }} onClick={() => submitForm("A")} />
                                <Button
                                    className="p-button-secondary p-button btn-hidden-responsive"
                                    icon="pi pi-arrow-left"
                                    label="กลับหน้าจอหลัก" // style={{ marginLeft: "5px" }}
                                    style={{ width: 170, marginLeft: "5px" }}
                                    onClick={() => handlerGoPage({ page: "233" })}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
